<template>
  <div id="modalPortefeuille">
    <b-button v-b-modal="'modal-' + this.uid"
      >Votre portefeuille sélectionné {{ sec.length }}</b-button
    >

    <b-modal
      modal-class="customCompModal"
      :id="'modal-' + this.uid"
      hide-footer
      centered
      size="xl"
      @hide="onHide"
    >
      <template #modal-header="{ close }">
        <h5>Votre portefeuille</h5>
        <b-icon icon="x" @click="close()"></b-icon>
      </template>
      <form method="POST" @submit="checkForm" action="/first_portfolio/choose">
        <template v-if="platform">
          <div style="width: 100%">
            <input type="hidden" name="_token" :value="token" />
            <input type="hidden" :name="'form[year]'" :value="year" />
            <input type="hidden" :name="'form[amount]'" :value="amount" />
            <input
              type="hidden"
              :name="'form[platform]'"
              :value="platform.id"
            />
            <input
              type="hidden"
              :name="'form[contract]'"
              :value="contract.id"
            />
            <b-table
              striped
              hover
              :fields="fields"
              :items="sec"
              :per-page="perPage"
              :current-page="currentPage"
              responsive
              class="mf_custom_table"
            >
              <template #head(th1)="data">
                <div class="tbHeader">
                  <span class="tbHeader_label">{{ data.label }}</span>
                </div>
              </template>
              <template #head(th2)="data">
                <div class="tbHeader">
                  <span class="tbHeader_label">{{ data.label }}</span>
                </div>
              </template>
              <template #head(score2)="data">
                <div class="tbHeader">
                  <span class="tbHeader_label">{{ data.label }}</span>
                </div>
              </template>
              <template #head(portefeuille)="data">
                <div class="tbHeader">
                  <span class="tbHeader_label">{{ data.label }}</span>
                </div>
              </template>
              <template #cell(th1)="data">
                <input
                  type="hidden"
                  :name="'form[' + data.index + '][id]'"
                  :value="data.item.id"
                />
                <input
                  type="hidden"
                  style="font-size: 11px"
                  :name="'form[' + data.index + '][name]'"
                  :value="data.item.name"
                />
                <input
                  type="hidden"
                  style="font-size: 11px"
                  :name="'form[' + data.index + '][isin]'"
                  :value="data.item.isin"
                />
                <span class="tb_col_etf">{{ data.item.name }} </span>
              </template>
              <template #cell(th2)="data">
                <span class="tb_col_score">{{ data.item.isin }} </span>
              </template>
              <template #cell(th3)="data">
                <span class="tb_col_score">{{
                  data.item.esg_score_aggregated
                }}</span>
              </template>
              <template #cell(th4)="data">
                <span class="tb_col_score">{{
                  Math.round(data.item.sharpe_ratio * 100) / 100
                }}</span>
              </template>
              <template #cell(th5)="data">
                <button
                    style="font-size: 32px!important; text-align:center; vertical-align:middle; color:red;"
                    type="button"
                    class="close"
                    aria-label="Close"
                    v-on:click="sec.splice(sec.indexOf(data), 1)">
                    <span aria-hidden="true">&times;</span>
                </button>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </template>
        <b-row>
          <b-button class="btnCustomSubmit triggerspinner" type="submit">
            Optimiser mon portefeuille
          </b-button>
        </b-row>
        <b-row>
          <div class="form_error">
            <p v-if="errors.length">
              <span v-for="(error, i) in errors" :key="i">{{ error }}</span>
            </p>
          </div>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>
<script>
$(function() {
  $(".triggerspinner").click(function() {
    $("#overlay").fadeIn();
  });
});

export default {
  props: ["sec", "year", "amount", "platform", "contract", "token"],
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: "th1", label: "Position" },
        { key: "th2", label: "ISIN" },
        { key: "th3", label: "Score impact" },
        { key: "th4", label: "Score performeur" },
        { key: "th5", label: "" }
      ],
      errors: []
    };
  },
  computed: {
    rows() {
      return this.sec.length;
    }
  },
  methods: {
    onHide() {
      setTimeout(() => {
        this.errors = [];
      }, 1000);
    },
    checkForm: function(e) {
      if (this.sec.length > 1) {
        return true;
      }
      this.errors = [];

      if (this.sec.length === 1) {
        this.errors.push(
          "Veuillez sélectionner plus d'un titre pour constituer votre portefeuille."
        );
      }
      if (this.sec.length < 1) {
        this.errors.push(
          "Veuillez selectionner au minimum deux titres pour constituer votre portefeuille."
        );
      }

      e.preventDefault();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

.modal-header {
  border-bottom: none;
}

#modalPortefeuille {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  .customCompModal {
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1040;
      width: 100vw;
      height: 100vh;
      background-color: rgb(0 0 0 / 50%);
    }

    .modal-content {
      box-shadow: $boxShadow;
      background-color: $bg_color;
      border-radius: 33px !important;
      color: $lt_grey_color;
      padding: 15px;

      .modal-body {
        text-align: justify;
      }

      .modal-header {
        border-bottom: none !important;
      }
    }

    .modalContentCustom {
      text-align: justify;
    }
  }
  tr {
    text-align: center;
  }
  button {
    box-shadow: $boxShadow;
    border-radius: 41px;
    background: $purple_color;
    width: 50%;
    margin: auto;
  }
}
.form_error {
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: center;
  color: $mf_ft_color_error;
}
.btnCustomSubmit {
  background: $purple_color !important;
  width: 50% !important;
  border-radius: 41px !important;
  margin: auto !important;
  margin-top: 20px !important;
}
</style>